import { get, post } from '@core/request';

/**
 * 操作日志上报接口
 * @param {Object} data - 操作日志参数
 * @param {string} data.entityType - 实体类型，如：'case', 'expert', 'organization', ...
 * @param {string} data.entityId - 实体ID，对应实体的唯一标识
 * @param {string} data.module - 业务模块，如：'selection', 'expert', 'organization', ...
 * @param {string} [data.portal] - 端口标识（可选），如：'boss', 'partner'，用于区分同一个 module 在不同端口
 * @param {string} data.operationType - 操作类型，如：'create', 'update', 'approve', 'reject', 'merge', 'publish', 'unpublish', ...
 * @param {string} data.operationDesc - 操作描述，如：'新增机构', '编辑机构', '审核通过', '审核驳回，驳回理由：{{rejection_reason}}', '合并机构，被合并机构：机构1（#24343），机构2（#234343）', '上架实践', '下架实践', ...
 * @param {Object} [data.extra] - 扩展信息字段（可选），存储额外的JSON格式数据
 * @param {string} [data.result] - 操作结果（可选）：'success' 或 'failed'
 * @param {Object} [data.dataSnapshot] - 数据快照（可选），记录操作前后的数据状态（通常为JSON格式）
 * @param {string} [data.memcard] - 用户ID（可选），前端操作时的用户标识（普通用户）
 * @param {number} [data.adminId] - 管理员ID（可选），运营管理系统操作时的管理员标识
 * @param {string} [data.adminPhone] - 管理员手机号（可选）
 * @param {string} [data.adminName] - 管理员姓名（可选）
 * @returns {Promise} 返回操作结果
 */
export const saveOperationLogApi = data => post('/applog/operationLog/save', data);

/**
 * 操作日志查询接口
 * @param {Object} params - 查询参数
 * @param {string} params.entityType - 实体类型，如：'case', 'expert', 'organization', ...
 * @param {string} params.entityId - 实体ID，对应实体的唯一标识
 * @param {string} [params.module] - 业务模块（可选），如：'selection', 'expert', 'organization', ...
 * @param {number} [params.page] - 页码（可选）
 * @param {number} [params.size] - 每页大小（可选）
 * @returns {Promise} 返回操作日志列表
 */
export const getOperationLogListApi = params => get('/applog/operationLog/list', params);

/**
 * 查询操作日志（根据 JSON 类型字段 extra 进行日志筛选）
 *
 * 先通过实体类型和实体ID做初步筛选，再通过添加 extra JSON类型字段的筛选条件缩小日志范围。
 * 可传多个 extra 筛选条件。
 * 由于JSON字段可以有多层结构，在条件中，通过 path 和 search_str 查询，path 用于定位 JSON
 * 中的属性，search_str 用于该属性的值的对比。
 *
 * @param {Object} data - 查询参数
 * @param {string} data.module - 业务模块（必填）
 * @param {string} [data.portal] - 端口（可选，如：'boss', 'partner'）
 * @param {string} [data.entityType] - 实体类型（可选，如：'conference', 'guestjourney'）
 * @param {number} [data.entityId] - 实体ID（可选）
 * @param {string} [data.operationType] - 操作类型（可选，如：'create', 'update', 'delete'）
 * @param {Array<Object>} [data.conditions] - 筛选条件数组（可选）
 * @param {string} data.conditions[].path - JSON 字段 extra 中的路径，如 'expertInfo.expertId' 或 'expertInfo.expertName'
 * @param {string|number} data.conditions[].search_str - 通过 path 查询的值
 * @returns {Promise} 返回操作日志列表
 */
export const getOperationLogListWithExtra = data => post('/applog/operationLog/listWithExtra', data);
